"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmationDialog = void 0;
var _react = require("react");
var _alertDialog = require("@design/ui/alert-dialog");
var _jsxRuntime = require("react/jsx-runtime");
var ConfirmationDialog = exports.ConfirmationDialog = function ConfirmationDialog(_ref) {
  var tone = _ref.tone,
    title = _ref.title,
    message = _ref.message,
    confirmLabel = _ref.confirmLabel,
    _ref$cancelLabel = _ref.cancelLabel,
    cancelLabel = _ref$cancelLabel === void 0 ? "Cancel" : _ref$cancelLabel,
    confirmDisabled = _ref.confirmDisabled,
    cancelDisabled = _ref.cancelDisabled,
    focusFallbackRef = _ref.focusFallbackRef,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm;
  var invokingControlRef = (0, _react.useRef)(null);
  function returnFocusToInvokingControl(event) {
    var invokingControl = invokingControlRef.current;
    var returnTarget = invokingControl !== null && invokingControl !== void 0 && invokingControl.isConnected ? invokingControl : focusFallbackRef === null || focusFallbackRef === void 0 ? void 0 : focusFallbackRef.current;
    if (!returnTarget) return;
    event.preventDefault();
    returnTarget.focus();
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialog, {
    open: true,
    "data-sentry-element": "AlertDialog",
    "data-sentry-component": "ConfirmationDialog",
    "data-sentry-source-file": "confirmation-dialog.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogContent, {
      size: "sm",
      onOpenAutoFocus: function onOpenAutoFocus() {
        invokingControlRef.current = document.activeElement;
      },
      onCloseAutoFocus: returnFocusToInvokingControl,
      onEscapeKeyDown: function onEscapeKeyDown(event) {
        event.preventDefault();
        if (!cancelDisabled) onCancel();
      },
      "data-sentry-element": "AlertDialogContent",
      "data-sentry-source-file": "confirmation-dialog.tsx",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogHeader, {
        "data-sentry-element": "AlertDialogHeader",
        "data-sentry-source-file": "confirmation-dialog.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogTitle, {
          "data-sentry-element": "AlertDialogTitle",
          "data-sentry-source-file": "confirmation-dialog.tsx",
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogDescription, {
          asChild: true,
          "data-sentry-element": "AlertDialogDescription",
          "data-sentry-source-file": "confirmation-dialog.tsx",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: message
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_alertDialog.AlertDialogFooter, {
        "data-sentry-element": "AlertDialogFooter",
        "data-sentry-source-file": "confirmation-dialog.tsx",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogCancel, {
          disabled: cancelDisabled,
          onClick: onCancel,
          "data-sentry-element": "AlertDialogCancel",
          "data-sentry-source-file": "confirmation-dialog.tsx",
          children: cancelLabel
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_alertDialog.AlertDialogAction, {
          variant: tone === "destructive" ? "destructive" : "default",
          disabled: confirmDisabled,
          onClick: onConfirm,
          "data-sentry-element": "AlertDialogAction",
          "data-sentry-source-file": "confirmation-dialog.tsx",
          children: confirmLabel
        })]
      })]
    })
  });
};